module.exports = __webpack_public_path__ + "media/images/footer-upper-5076fa29d9f7278c2c756c6b38dcc499.png";